__webpack_require__.p = "//static.simplebooth.com/virtual-booth/v1.5.5/";